__turbopack_context__.v({
  "bottomad": "HomePageLayoutWithAds-module__Czgm7a__bottomad",
  "container": "HomePageLayoutWithAds-module__Czgm7a__container",
  "containerWithMargin": "HomePageLayoutWithAds-module__Czgm7a__containerWithMargin",
  "noContainerMargin": "HomePageLayoutWithAds-module__Czgm7a__noContainerMargin",
  "noTopAd": "HomePageLayoutWithAds-module__Czgm7a__noTopAd",
});
